import { HttpInterceptorFn } from "@angular/common/http";
import { AuthInterceptor } from "./auth.interceptor";

export const interceptors: HttpInterceptorFn[] = [
    AuthInterceptor
]